import * as Zod from 'zod';

import { translate } from 'utils/i18n';

const minMaxFilterValidator = Zod.object({
    groupId: Zod.string(),
    min: Zod.coerce.number<number>().int().nonnegative().optional().nullable(),
    max: Zod.coerce.number<number>().int().nonnegative().optional().nullable(),
})
    .refine(
        (data) =>
            !data.min ||
            !data.max ||
            (data.min && data.max && !!data.max && data.min <= data.max),
        {
            message: translate('validate.lessOrEqual'),
            path: ['min'],
        }
    )
    .refine(
        (data) => !data.max || (!!data.max && data.max >= (data?.min ?? 0)),
        {
            message: translate('validate.moreOrEqual'),
            path: ['max'],
        }
    );

const groupConditionExtraCategoryValueValidator = Zod.object({
    id: Zod.string(),
    stringValue: Zod.string().optional().nullable(),
});

export const groupConditionValidator = Zod.object({
    id: Zod.string().optional(),
    groups: Zod.array(Zod.string()),
    extraCategoryValues: Zod.array(
        groupConditionExtraCategoryValueValidator
    ).optional(),
    minMaxFilters: Zod.array(minMaxFilterValidator).optional(),
});
